import { apiDate, number, optionalString, string, uuid, zodLess, ZodLessInfer } from '@kaiizen/zod-less';
import { optionalApiDate } from '../schemaLib';

export const ApiNotificationSchema = zodLess({
  id: uuid,
  userId: uuid,
  orgId: uuid,
  title: string,
  text: optionalString,
  readAt: optionalApiDate,
  createdAt: apiDate,
  updatedAt: apiDate,

  scanId: uuid.optional(),
  scanTemplateId: uuid.optional(),
  scanNoteId: uuid.optional(),
  orgPropertyId: uuid.optional(),
  orgMarketId: uuid.optional(),
  orgContractorId: uuid.optional(),
  orgProductId: uuid.optional(),
  propertyProjectId: uuid.optional(),
  aboutUserId: uuid.optional(),
  actorUserId: optionalString,
  actorUserName: optionalString,
  propertyId: optionalString,
  propertyIdLabel: optionalString,
});
export type ApiNotification = ZodLessInfer<typeof ApiNotificationSchema>;

export const ApiNotificationListResponseSchema = zodLess({
  notifications: [ApiNotificationSchema],
  nextCursor: optionalString,
  unreadCount: number,
});
export type ApiNotificationListResponse = ZodLessInfer<typeof ApiNotificationListResponseSchema>;

export const ApiNotificationReadResponseSchema = zodLess({
  updatedCount: number,
  unreadCount: number,
});
export type ApiNotificationReadResponse = ZodLessInfer<typeof ApiNotificationReadResponseSchema>;
export const getNotificationsQueryKey = () => 'notifications';
